import React from 'react';
type LeafSprigProps = {
  className?: string;
};
export function LeafSprig({
  className = ''
}: LeafSprigProps) {
  return <svg viewBox="0 0 64 120" className={className} fill="currentColor" aria-hidden="true" data-id="element-67" data-mp="15tksqe2oqj56">
      <path d="M32 118 C32 80 31 45 33 4" stroke="currentColor" strokeWidth="2.5" fill="none" strokeLinecap="round" data-id="element-68" data-mp="19tbm8pjljdde" />
      <path d="M32 92c-14-2-22-12-23-24 12 1 21 9 23 24z" data-id="element-69" data-mp="1emnzk3itrxqu" />
      <path d="M32 78c13-3 20-13 20-25-11 2-19 10-20 25z" data-id="element-70" data-mp="1jkpm4yfgmf72" />
      <path d="M32 56c-12-2-19-11-19-21 10 1 18 8 19 21z" data-id="element-71" data-mp="1jmahgq9lm25z" />
      <path d="M33 40c11-3 17-11 17-21-9 2-16 9-17 21z" data-id="element-72" data-mp="1ohzh0tlmbj2a" />
      <path d="M33 20c-7-2-11-8-11-15 6 1 10 6 11 15z" data-id="element-73" data-mp="1tidoa9feaoz9" />
    </svg>;
}